registerComponent("product-blocks/product-asa-distressed-processo-de-investimento", function (component) {

});
